import { jsx as _jsx } from "preact/jsx-runtime";
import { createContext, useEffect, useRef, useState } from 'react';
// Show after 30 seconds when no video is present on the page
const SHOW_AFTER_MS = 30000;
// Show after 15 seconds when video is present on the page, and only after
const SHOW_AFTER_MS_VIDEO_CLOSE = 15000;
const HIDE_AFTER_MS = 6000;
export const TooltipContext = createContext({});
export const TooltipContextProvider = ({ children, isMobileWithVideo, }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [state, setState] = useState('normal');
    const stateRef = useRef(state);
    stateRef.current = state;
    useEffect(() => {
        /* Mobile only with Video Tooltip display logic */
        if (isMobileWithVideo) {
            /*
             * setInterval was chosen as a mechanism for finding out if the Video Player has been closed on Mobile.
             * The VideoPlayer creates a hidden input element, and when the user dismisses the sticky VideoPlayer,
             * this hidden input element's value gets set to "true" through Javascript/React code.
             *
             * There was consideration to use mutationObserver, however it looks like changing the input element's value
             * through the browser API (through JavaScript code), does not trigger a DOM mutation event when the input element
             * or even the parent element is observed on.
             *
             * As a result of this limitation, the setInterval function was chosen to check the input element's value every second.
             * Once the value is changed to true, we clear the interval id, and continue on with doing a timeout wait to display the tooltip
             * after a certain amount of time.
             * */
            const intervalId = setInterval(() => {
                const mobilePlayerIsClosed = document.querySelector(`[name="isDismissed"]`);
                if (mobilePlayerIsClosed && mobilePlayerIsClosed.value === 'true') {
                    clearInterval(intervalId);
                    const timeoutToShow = setTimeout(() => {
                        // check if tooltip is still in default state, otherwise don't show it
                        if (state === 'normal') {
                            setIsVisible(true);
                            // schedule closing tooltip
                            setTimeout(() => {
                                if (stateRef.current === 'normal') {
                                    setIsVisible(false);
                                    setState('closed');
                                }
                            }, HIDE_AFTER_MS);
                        }
                    }, SHOW_AFTER_MS_VIDEO_CLOSE);
                    return () => clearTimeout(timeoutToShow);
                }
            }, 1000);
        }
        else {
            /* All other display logic. For example:
             *
             * Desktop with video
             * Desktop without video
             *
             * Mobile without video
             * */
            const timeoutToShow = setTimeout(() => {
                // check if tooltip is still in default state, otherwise don't show it
                if (state === 'normal') {
                    setIsVisible(true);
                    // schedule closing tooltip
                    setTimeout(() => {
                        if (stateRef.current === 'normal') {
                            setIsVisible(false);
                            setState('closed');
                        }
                    }, HIDE_AFTER_MS);
                }
            }, SHOW_AFTER_MS);
            return () => clearTimeout(timeoutToShow);
        }
    }, []);
    const onClose = () => {
        setState('closed');
        setIsVisible(false);
    };
    const onFollow = (isFollowing) => {
        setState(isFollowing ? 'following' : 'unfollowing');
        setIsVisible(true);
    };
    return (_jsx(TooltipContext.Provider, Object.assign({ value: {
            isVisible,
            type: state !== 'closed' ? state : 'normal',
            onClose,
            onFollow,
        } }, { children: children }), void 0));
};
